import type { SubscriptionPlan } from '../services/types/subscription';

export function getSubscriptionPlans(t: (key: string) => string): SubscriptionPlan[] {
    return [
        {
            id: 1,
            name: t('subscription.plan_basic_name'),
            description: t('subscription.plan_basic_description'),
            monthlyPrice: '1',
            yearlyPrice: '12',
            features: [
                t('subscription.plan_basic_features.0'),
                t('subscription.plan_basic_features.1'),
                t('subscription.plan_basic_features.2')
            ],
            available: true
        },
        {
            id: 2,
            name: t('subscription.plan_advanced_name'),
            description: t('subscription.plan_advanced_description'),
            monthlyPrice: t('subscription.comingSoon'),
            yearlyPrice: t('subscription.comingSoon'),
            features: [
                t('subscription.plan_advanced_features.0'),
                t('subscription.plan_advanced_features.1'),
                t('subscription.plan_advanced_features.2')
            ],
            available: false
        },
        {
            id: 3,
            name: t('subscription.plan_premium_name'),
            description: t('subscription.plan_premium_description'),
            monthlyPrice: t('subscription.comingSoon'),
            yearlyPrice: t('subscription.comingSoon'),
            features: [
                t('subscription.plan_premium_features.0'),
                t('subscription.plan_premium_features.1'),
                t('subscription.plan_premium_features.2'),
                t('subscription.plan_premium_features.3')
            ],
            available: false
        }
    ];
}
